// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c49faa07","521":"f851d8f5","617":"aa55521f","651":"4de0c1f5","736":"65dc2067","934":"eef3e735"}[chunkId] + ".chunk.js";
};